import { useEffect } from "react";
import { attendancesRef, connectedRef, onDisconnect, onValue, ref, remove, set, useValue, } from "../index.js";
const useAttendancesObserver = ({ roomKey, userId, }) => {
    useEffect(() => {
        const attendanceRef = [attendancesRef, roomKey, userId];
        const attendanceDatabaseRef = ref(...attendanceRef);
        const disconnect = onDisconnect(attendanceDatabaseRef);
        let active = true;
        let connected = false;
        let connectionGeneration = 0;
        const registerPresence = () => {
            const generation = connectionGeneration;
            if (!active || !connected) {
                return;
            }
            void disconnect
                .remove()
                .then(() => {
                if (active && connected && generation === connectionGeneration) {
                    return set(...attendanceRef)(true);
                }
            })
                .catch(console.error);
        };
        const unsubscribeConnected = onValue(ref(connectedRef), (snapshot) => {
            connectionGeneration++;
            connected = snapshot.val() === true;
            registerPresence();
        });
        return () => {
            active = false;
            connected = false;
            connectionGeneration++;
            unsubscribeConnected();
            void disconnect.cancel().catch(console.error);
            void remove(...attendanceRef).catch(console.error);
        };
    }, [roomKey, userId]);
};
export const AttendancesObserver = (params) => {
    useAttendancesObserver(params);
    return null;
};
export const useAttendances = (roomKey, options = {}) => useValue(attendancesRef, roomKey)(options);
//# sourceMappingURL=Attendances.js.map